<ct-lib-modal
  #modal
  [big]="true"
  [hideFooter]="true"
  [label]="
    'company-tool.views.settings.company.payment.credits-log.title' | transloco
  "
>
  <div class="credits-log">
    <div class="table-wrapper">
      <div class="table-overflow-wrapper">
        <p-table
          [value]="entries()"
          [paginator]="true"
          [rows]="recordsPerPage"
          [totalRecords]="totalRecords()"
          [first]="offset()"
          breakpoint="768px"
          [lazy]="true"
          (onLazyLoad)="onLoadEvent($event)"
          dataKey="id"
          [scrollable]="true"
          [lazyLoadOnInit]="false"
          [hidden]="entries().length === 0"
          [scrollHeight]="'flex'"
          paginatorPosition="bottom"
        >
          <ng-template #header>
            <tr>
              <th>
                {{
                  'company-tool.views.settings.company.payment.credits-log.headers.time'
                    | transloco
                }}
              </th>
              <th>
                {{
                  'company-tool.views.settings.company.payment.credits-log.headers.action'
                    | transloco
                }}
              </th>
              <th>
                {{
                  'company-tool.views.settings.company.payment.credits-log.headers.amount'
                    | transloco
                }}
              </th>
              <th>
                {{
                  'company-tool.views.settings.company.payment.credits-log.headers.type'
                    | transloco
                }}
              </th>
              <th>
                {{
                  'company-tool.views.settings.company.payment.credits-log.headers.user'
                    | transloco
                }}
              </th>
              <th>
                {{
                  'company-tool.views.settings.company.payment.credits-log.headers.job'
                    | transloco
                }}
              </th>
              <th>
                {{
                  'company-tool.views.settings.company.payment.credits-log.headers.application'
                    | transloco
                }}
              </th>
            </tr>
          </ng-template>
          <ng-template #body let-entry>
            <tr>
              <td class="table-date-column">
                {{ entry.creationTime | date: 'short' }}
              </td>
              <td>
                {{ actionLabelKey(entry) | transloco }}
              </td>
              <td>
                <div class="amount-cell">
                  <ct-lib-tag
                    [variant]="amountTagVariant(entry)"
                    [accentColor]="amountTagAccent(entry)"
                  >
                    @if (isReset(entry)) {
                      <fa-icon
                        class="amount-reset-icon"
                        [icon]="fontawesomeService.light.rotate"
                        aria-hidden="true"
                      ></fa-icon>
                    }
                    {{ signedAmount(entry) }}
                  </ct-lib-tag>
                  <span class="amount-balance">
                    {{
                      'company-tool.views.settings.company.payment.credits-log.balance-label'
                        | transloco
                    }}
                    {{ entry.balanceAfter }}
                  </span>
                </div>
              </td>
              <td>
                {{ typeLabelKey(entry) | transloco }}
              </td>
              <td>
                @if (userDisplayName(entry); as userName) {
                  {{ userName }}
                } @else {
                  {{ 'company-tool.other.system' | transloco }}
                }
              </td>
              <td>{{ entry.jobTitle || '-' }}</td>
              <td>
                @if (applicationDisplayName(entry); as applicationName) {
                  {{ applicationName }}
                } @else {
                  -
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      @if (entries().length === 0 && !loading()) {
        <ct-lib-empty-placeholder
          [title]="
            'company-tool.views.settings.company.payment.credits-log.empty'
              | transloco
          "
          text=""
          [icon]="fontawesomeService.light.list"
        ></ct-lib-empty-placeholder>
      }
      @if (loading()) {
        <app-view-loader [loading]="true" [overlay]="true"></app-view-loader>
      }
    </div>
  </div>
</ct-lib-modal>
